import { useEffect, useMemo, useState } from "react";
import { useAccountV2ErrorHandling } from "./useAccountV2ErrorHandling.js";
import { RealCommerceError } from "../../../exceptions/realCommerceError.js";
import { useStores } from "../../../store/stores.js";
/**
 * Use the `?user-confirmation-code=` parameter and activate the devowl.io account for that purchase.
 */ function useUserConfirmationCode() {
    const { accountV2Store } = useStores();
    const params = useMemo(()=>new URLSearchParams(window.location.search), []);
    const [isBusy, setIsBusy] = useState(false);
    const [result, setResult] = useState();
    const [confirmationToken] = useState(params.get("user-confirmation-code") || undefined);
    const handleRealCommerceError = useAccountV2ErrorHandling();
    useEffect(()=>{
        if (confirmationToken) {
            const post = async ()=>{
                const newUrl = window.location.href.replace(/([?]?user-confirmation-code=\w{8}-\w{4}-\w{4}-\w{4}-\w{12}[&]?)/gm, "");
                window.history.replaceState({}, document.title, newUrl);
                setIsBusy(true);
                try {
                    setResult(await accountV2Store.confirmDoubleOptIn(confirmationToken));
                } catch (e) {
                    if (e instanceof RealCommerceError) {
                        handleRealCommerceError(e);
                    }
                } finally{
                    setIsBusy(false);
                }
            };
            post();
        }
    }, []);
    return {
        confirmationToken,
        isBusy,
        result
    };
}
export { useUserConfirmationCode };
